import { render, staticRenderFns } from "./RipaAlert.vue?vue&type=template&id=8a861c52"
import script from "./RipaAlert.vue?vue&type=script&lang=js"
export * from "./RipaAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports